import { render, staticRenderFns } from "./paperSetting.vue?vue&type=template&id=2c2b5b66&scoped=true&"
import script from "./paperSetting.vue?vue&type=script&lang=ts&"
export * from "./paperSetting.vue?vue&type=script&lang=ts&"
import style0 from "./paperSetting.vue?vue&type=style&index=0&id=2c2b5b66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b5b66",
  null
  
)

export default component.exports